import styled, { css } from "styled-components";
import {
  TituloH1 as TituloPrincipal,
  Sorriso as IconSorriso,
  Descricao,
} from "../../../../components/TituloSorriso/styles";
import { media } from "../../../../layouts/utils";

export const Sorriso = styled(IconSorriso)`
  margin-bottom: 0;
`;

export const TextWrap = styled.div`
  padding: 40px 20px 40px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled(TituloPrincipal)`
  ${media.desktop`
    max-width: 100%;
    line-height: 28px;
    font-size: 32px;
  `}
  font-size: 32px;
  padding: 0;
  text-align: center;
  max-width: 300px;
  margin-bottom: 10px;
  line-height: 45px;
`;

export const Text = styled(Descricao)`
  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;
  `}
  ${media.tablet`
    max-width: 80%;
  `}
  max-width: 50%;
  padding: 0;
  text-align: center;
  margin-top: 16px;
`;

export const Link = styled.a`
  text-decoration: none;
  ${({ disabled }) => disabled && `cursor: not-allowed; pointer-events: none;`}
  margin-top: 32px;
`;

const buttonEnabled = css`
  cursor: pointer;
  color: ${({ color }) => color};
  &:hover {
    height: 4rem;
    //to balance new height colateral
    margin-bottom: -0.5rem;
    margin-right: -0.5rem;
    min-width: 15rem; // + .5em from default
    padding: 1rem 2.25rem;
    //to balance side padding collateral
    transform: translate(-0.25rem, -0.25rem);
  }
`;

const buttonDisabled = css`
  cursor: not-allowed;
  background: ${({ backgroundColor }) => backgroundColor} !important;
  color: ${({ color }) => color};
  opacity: 0.6;
`;

export const Button = styled.div`
  user-select: none;
  height: 3.5rem;
  min-width: 14rem;
  padding: 0.9rem 2rem;
  font-family: "Galano Grotesque Alt";
  font-size: 1rem;
  transition: all 0.1s ease-in 0s;
  border-radius: 9999px;
  text-align: center;
  color: #fff;
  background: #230c87;
  ${({ disabled }) => (disabled ? buttonDisabled : buttonEnabled)}
`;
